import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { api } from "@/lib/api";

const HIDE_ON = /^\/(admin|donate|join|thank-you|registration-confirmed|events\/.*\/register)/;

export default function FloatingCTA() {
  const { t, lang } = useI18n();
  const loc = useLocation();
  const [visible, setVisible] = useState(false);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    api.get("/site-settings").then(r => setSettings(r.data)).catch(() => setSettings(null));
  }, []);

  if (HIDE_ON.test(loc.pathname)) return null;
  const cta = settings?.floating_cta;
  if (cta && cta.show === false) return null;

  const T = (obj) => (obj && (obj[lang] || obj.en || obj.da)) || "";
  const to = (cta && cta.url) || "/join";
  const label = T(cta?.label) || t("float_join");
  const labelMobile = T(cta?.label_mobile) || t("float_join_mobile");

  return (
    <Link
      to={to}
      data-testid="floating-cta"
      className={`fixed z-40 bottom-6 right-6 md:bottom-8 md:right-8 bg-terracotta hover:bg-terracotta-dark text-white shadow-2xl transition-all duration-500
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 pointer-events-none translate-y-4"}
        px-5 md:px-6 py-3.5 md:py-4 text-sm tracking-wide inline-flex items-center gap-2 rounded-full`}
    >
      <Heart size={16} strokeWidth={1.8} />
      <span className="hidden md:inline">{label}</span>
      <span className="md:hidden">{labelMobile}</span>
    </Link>
  );
}
